import { PERMISSIONS } from "@miplatform/constants";
import { IPermission } from "@miplatform/types";

export const preFilterModulePermissions = (
  permissions: IPermission[]
): IPermission[] => {
  return permissions.filter(
    (permission: IPermission) =>
      ![
        PERMISSIONS.MI_DISPATCH.ACCESS,
        PERMISSIONS.MI_SCHEDULING.ACCESS,
        PERMISSIONS.MI_ACCOUNTING.ACCESS,
        PERMISSIONS.MI_ESTIMATING.ACCESS,
        PERMISSIONS.MI_INSPECTIONS.ACCESS,
        PERMISSIONS.MIBUILD_MOBILE.ACCESS,
        PERMISSIONS.SYSTEM_ADMINISTRATION.ADMINISTRATION,

        // We will filter out the admin permissions to later add by checking the list of modules selected
        PERMISSIONS.MI_DISPATCH.ADMINISTRATION,
        PERMISSIONS.MI_SCHEDULING.ADMINISTRATION,
        PERMISSIONS.MI_ACCOUNTING.ADMINISTRATION,
        PERMISSIONS.MI_ESTIMATING.ADMINISTRATION,
        PERMISSIONS.MI_INSPECTIONS.ADMINISTRATION,
        PERMISSIONS.MIBUILD_MOBILE.ADMINISTRATION,
      ].includes(permission.name)
  );
};
